import type { ApiFlow } from '../types'

export const federationEnterpriseLoginFlow: ApiFlow = {
  id: 'federation.enterprise-login',
  appTypes: ['spa', 'web', 'native'],
  title: 'Enterprise federation login',
  summary:
    'When the tenant has federation providers, start with method=federation:fcon_* and follow federation_redirect.',
  steps: [
    {
      id: 'config',
      title: 'Read federation providers',
      when: 'Login screen loads — show "Continue with Microsoft" etc.',
      method: 'GET',
      path: '/api/v1/auth/config',
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            data: {
              federation_providers: [
                {
                  id: 'fcon_01HXXXXXXXXXXXXXXXXXXXXXX',
                  display_name: 'Microsoft',
                  method: 'federation:fcon_01H...',
                },
              ],
            },
          },
          nextStepId: 'start',
        },
      ],
    },
    {
      id: 'start',
      title: 'Start federation login',
      when: 'User picks an enterprise IdP',
      method: 'POST',
      path: '/api/v1/auth/start',
      requestBody: {
        method: 'federation:fcon_01HXXXXXXXXXXXXXXXXXXXXXX',
        identifier: '',
        client_mode: 'browser',
        login_challenge: '<optional-oauth-challenge>',
      },
      responseVariants: [
        {
          label: 'pending redirect',
          status: 200,
          body: {
            data: {
              status: 'pending',
              flow_id: 'flw_01HXXXXXXXXXXXXXXXXXXXXXX',
              pause: {
                kind: 'federation_redirect',
                redirect_url: 'https://login.microsoftonline.com/...',
                state: '<csrf-nonce>',
              },
            },
          },
          nextStepId: 'callback',
        },
      ],
      pauseKinds: ['federation_redirect'],
    },
    {
      id: 'callback',
      title: 'Federation callback',
      when: 'IdP redirects back to /auth/social-callback',
      method: 'POST',
      path: '/auth/social-callback',
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: { data: { status: 'success', redirect_to: '{{REDIRECT_URI}}?code=...' } },
        },
      ],
    },
  ],
}
